import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";
import { useState } from "react";
import { snackAdded } from "src/slices/system";
import { useDispatch } from "src/store";

type Props = {
  onClose: (briefId: string) => void;
  getConfirmation: (value: string) => void;
};

export const Confirmation = ({ onClose, getConfirmation }: Props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [isSubmitted, setIsSubmitted] = useState({
    advanced: false,
    continue: false,
  });

  return (
    <Box sx={{ p: 3, pt: 4, textAlign: "center", width: "464px" }}>
      <Typography
        align="left"
        gutterBottom
        color="#121828"
        /* Heading/H1 */
        fontFamily="Inter"
        fontSize="20px"
        fontStyle="normal"
        fontWeight="500"
        lineHeight="normal"
      >
        Let’s double-check
      </Typography>
      <Typography
        align="left"
        fontFamily="Inter"
        fontSize="14px"
        fontStyle="normal"
        fontWeight="400"
        color="#7B85AD"
        sx={{ mt: 2 }}
      >
        The 1-Click Generator might not showcase the full capabilities of
        SEOwind.
        {<br />}
        {<br />}
        If you choose Advanced Mode, SEOwind will create a detailed brief that
        you can edit and enhance. After that, you'll proceed to write the
        article with full control over the content.
        {<br />}
        {<br />}
        If you click Continue, SEOwind will automatically generate the article
        for you.
      </Typography>
      <Box display="flex" justifyContent="space-between" sx={{ pt: 3 }}>
        {isSubmitted.advanced ? (
          <Button
            sx={{ px: 7, ml: 1 }}
            size="large"
            variant="contained"
            disabled
          >
            <CircularProgress
              size={12}
              color="inherit"
              sx={{
                zIndex: 1,
                mr: 1,
              }}
            />
            Preparing...
          </Button>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            type="button"
            disabled={isSubmitted?.continue}
            onClick={() => {
              dispatch(
                snackAdded({
                  message: "Preparing advanced editor...",
                  type: "info",
                  duration: 2000,
                })
              );
              getConfirmation("advanced");
              setIsSubmitted({
                advanced: true,
                continue: false,
              });
            }}
            sx={{ ml: 1 }}
          >
            Advanced Mode
          </Button>
        )}
        {isSubmitted.continue ? (
          <Button
            sx={{ px: 7, mr: 1 }}
            size="large"
            variant="contained"
            disabled
          >
            <CircularProgress
              size={12}
              color="inherit"
              sx={{
                zIndex: 1,
                mr: 1,
              }}
            />
            Generating...
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            type="button"
            disabled={isSubmitted?.advanced}
            onClick={() => {
              dispatch(
                snackAdded({
                  message: "Starting article generation...",
                  type: "info",
                  duration: 2000,
                })
              );
              getConfirmation("continue");
              setIsSubmitted({
                advanced: false,
                continue: true,
              });
            }}
            sx={{ mr: 1 }}
          >
            Continue
          </Button>
        )}
      </Box>
    </Box>
  );
};
